// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.document

import org.multipaz.cbor.DataItem
import org.multipaz.document.DocumentData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.toDataItem
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr
import org.multipaz.cbor.buildCborArray

internal fun DocumentData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "w-V25ZnmvibIHlZddstHSOuQuLVe0D9vM6z4vEuq7iw")
internal val DocumentData_cborSchemaId = ByteString(-61, -27, 118, -27, -103, -26, -66, 38, -56, 30, 86, 93, 118, -53, 71, 72, -21, -112, -72, -75, 94, -48, 63, 111, 51, -84, -8, -68, 75, -86, -18, 44)

internal fun DocumentData.Companion.fromCbor(data: ByteArray): DocumentData {
    return DocumentData.fromDataItem(Cbor.decode(data))
}

internal val DocumentData.Companion.cborSchemaId: ByteString
    get() = DocumentData_cborSchemaId

internal fun DocumentData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("provisioned", this.provisioned.toDataItem())
    builder.put("created", this.created.toDataItemDateTimeString())
    val orderingKey = this.orderingKey
    if (orderingKey != null) {
        builder.put("orderingKey", Tstr(orderingKey))
    }
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val typeDisplayName = this.typeDisplayName
    if (typeDisplayName != null) {
        builder.put("typeDisplayName", Tstr(typeDisplayName))
    }
    val cardArt = this.cardArt
    if (cardArt != null) {
        builder.put("cardArt", Bstr(cardArt.toByteArray()))
    }
    val issuerLogo = this.issuerLogo
    if (issuerLogo != null) {
        builder.put("issuerLogo", Bstr(issuerLogo.toByteArray()))
    }
    val authorizationData = this.authorizationData
    if (authorizationData != null) {
        builder.put("authorizationData", Bstr(authorizationData.toByteArray()))
    }
    val appData = this.appData
    if (appData != null) {
        builder.put("appData", Bstr(appData.toByteArray()))
    }
    val mpzPassId = this.mpzPassId
    if (mpzPassId != null) {
        builder.put("mpzPassId", Tstr(mpzPassId))
    }
    val mpzPassVersion = this.mpzPassVersion
    if (mpzPassVersion != null) {
        builder.put("mpzPassVersion", mpzPassVersion.toDataItem())
    }
    val readerIdentifiers = this.readerIdentifiers
    if (readerIdentifiers != null) {
        val array = readerIdentifiers.let {
            buildCborArray {
                for (value in it) {
                    add(Bstr(value.toByteArray()))
                }
            }
        }
        builder.put("readerIdentifiers", array)
    }
    val metadata = this.metadata
    if (metadata != null) {
        builder.put("metadata", Bstr(metadata.toByteArray()))
    }
    val tagsData = this.tagsData
    if (tagsData != null) {
        builder.put("tagsData", Bstr(tagsData.toByteArray()))
    }
    return builder.end().build()
}

internal fun DocumentData.Companion.fromDataItem(dataItem: DataItem): DocumentData {
    val provisioned = dataItem["provisioned"].asBoolean
    val created = dataItem["created"].asDateTimeString
    val orderingKey0 = if (dataItem.hasKey("orderingKey")) {
        dataItem["orderingKey"].asTstr
    } else {
        null
    }
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val typeDisplayName0 = if (dataItem.hasKey("typeDisplayName")) {
        dataItem["typeDisplayName"].asTstr
    } else {
        null
    }
    val cardArt0 = if (dataItem.hasKey("cardArt")) {
        dataItem["cardArt"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val issuerLogo0 = if (dataItem.hasKey("issuerLogo")) {
        dataItem["issuerLogo"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val authorizationData0 = if (dataItem.hasKey("authorizationData")) {
        dataItem["authorizationData"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val appData0 = if (dataItem.hasKey("appData")) {
        dataItem["appData"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val mpzPassId0 = if (dataItem.hasKey("mpzPassId")) {
        dataItem["mpzPassId"].asTstr
    } else {
        null
    }
    val mpzPassVersion0 = if (dataItem.hasKey("mpzPassVersion")) {
        dataItem["mpzPassVersion"].asNumber
    } else {
        null
    }
    val readerIdentifiers0 = if (dataItem.hasKey("readerIdentifiers")) {
        val array0 = dataItem["readerIdentifiers"].let {
            buildList<ByteString> {
                for (value in it.asArray) {
                    add(ByteString(value.asBstr))
                }
            }
        }
        array0
    } else {
        null
    }
    val metadata0 = if (dataItem.hasKey("metadata")) {
        dataItem["metadata"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val tagsData0 = if (dataItem.hasKey("tagsData")) {
        dataItem["tagsData"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    return DocumentData(
        provisioned = provisioned,
        created = created,
        orderingKey = orderingKey0,
        displayName = displayName0,
        typeDisplayName = typeDisplayName0,
        cardArt = cardArt0,
        issuerLogo = issuerLogo0,
        authorizationData = authorizationData0,
        appData = appData0,
        mpzPassId = mpzPassId0,
        mpzPassVersion = mpzPassVersion0,
        readerIdentifiers = readerIdentifiers0,
        metadata = metadata0,
        tagsData = tagsData0,
    )
}
